import { Button } from "@material-ui/core";
import { DataGrid, CellParams, GridApi } from "@material-ui/data-grid";
import React from "react";
import { markLocationAsDeleted } from "../../firestorter";

const LocationsTable = (props) => {
  
  const columns = [
    { field: "id", headerName: "ID" },
    { field: "name", headerName: "שם", width: 300},
    { field: "lastReport", headerName: "דיווח אחרון" },
    { field: "deleted", headerName: "מחוק" },
    // {
    //   field: "",
    //   headerName: "Action",
    //   disableClickEventBubbling: true,
    //   renderCell: (params: CellParams) => {
    //     const onClick = () => {
    //       const api: GridApi = params.api;
    //       const fields = api
    //         .getAllColumns()
    //         .map((c) => c.field)
    //         .filter((c) => c !== "__check__" && !!c);
    //       const thisRow = {};
  
    //       fields.forEach((f) => {
    //         thisRow[f] = params.getValue(f);
    //       });
  
          
    //       return alert(JSON.stringify(thisRow, null, 4));
    //     };
  
    //     return <Button onClick={onClick}>מחק</Button>;
    //   }
    // }
  ];

  const locations = (props.locations && props.locations.map((u) => u.data)) || [];

  const rows = locations.map((l,i) => {
    
    return {
      id:i,
      name: l.name,
      lastReport: l.lastReport && new Date(l.lastReport.createdOn.seconds * 1000).toDateString(),
      deleted: l.deleted
      
    };
  });

  return (
    <div style={{ height:"80vh", width: "100%" }}>
      <DataGrid rows={rows} columns={columns} checkboxSelection  >asdf</DataGrid>
    </div>
  );
};

export default LocationsTable;
